export default __webpack_public_path__ + "static/media/vecteezy_coffee_1209481.481b39e3.png";